import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { GroupForm } from "../../components/group/GroupForm";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import type { Apprentice } from "../../models/apprentice";
import type { Coach } from "../../models/coach";
import type { Group } from "../../models/group";
import type { YearContext } from "../../models/yearContext";
import { group_path, groups_path } from "../../routes";

type GroupEditProps = {
  group: Group;
  apprentice_options?: Apprentice[];
  year_contexts: YearContext[];
  coaches: Coach[];
};

export default function GroupEdit({ apprentice_options, year_contexts, coaches, group }: GroupEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(group_path, group.id), values);
  const convertedGroup: Group = { ...group, year_context: group.year_context };

  return (
    <ContentShell
      pageTitle={`Gruppe ${group.name} bearbeiten`}
      title={`Gruppe ${group.name}`}
      onBack={() => router.get(pathWithYearContext(groups_path))}
    >
      <GroupForm
        group={convertedGroup}
        apprenticeOptions={apprentice_options}
        yearContexts={year_contexts}
        coaches={coaches}
        submitButtonLabel="Speichern"
        onSubmit={onSubmit}
      />
    </ContentShell>
  );
}
